import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { IoClose } from "react-icons/io5";

// Sample student data (replace with your actual full list of 100+)
const studentData = [
  { name: "Dr. Tanu Manocha", course: "SEM Model" },
  { name: "Dr.Ranjit Thomas", course: "SEM Model" },
  { name: "Ms. Arathi J Nair", course: "SEM Model" },
  { name: "Nida Fathima", course: "SPSS 1" },
  { name: "Preeti kumbhar", course: "SPSS 1" },
  { name: "Mr. R. Kannan", course: "SPSS 1" },
  { name: "Dr Babita Kanojia", course: "SPSS 1" },
  { name: "Dhakshitha B K", course: "SPSS 1" },
  { name: "Debasmita Mondal", course: "SPSS 1" },
  { name: "Sowmiya A", course: "SPSS 1" },
  { name: "Debasmita Mondal", course: "SPSS 1" },
  { name: "Debasmita Mondal", course: "SPSS 1" },
  { name: "Mr. SAURAV UNIYAL", course: "SEM Model" },
  { name: "Miss Yangchen Doma Lepcha", course: "SEM Model" },
  { name: "Dr. Vinita Sharma", course: "SEM Model" },
  { name: "Mrs. Anusha K P", course: "SEM Model" },
  { name: "Mrs. NANCY.M", course: "SEM Model" },
  { name: "Mr Vinod Repalli", course: "SEM Model" },
  { name: "Dr Ramjit Kumar", course: "SEM Model" },
  { name: "NAZAR M H", course: "SEM Model" },
  { name: "SORNALATHA M E", course: "SEM Model" },
  { name: "Mrs. Simran Seth", course: "SEM Model" },
  { name: "Gurashish Kour", course: "SEM Model" },
  { name: "Prof.Sujata Missal", course: "SEM Model" },
  { name: "Ms. Sridevi Chinnaiah", course: "SEM Model" },
  { name: "Ms. Priya", course: "SEM Model" },
  { name: "Robin Roy", course: "SEM Model" },
  { name: "SAJEEV KUMAR A.P", course: "SEM Model" },
  { name: "Mr. D. Jeyandhan", course: "SEM Model" },
  { name: "Mrs. Bilfy V Sebastian", course: "SEM Model" },
  { name: "Dr Riddhi Sanghvi", course: "SEM Model" },
  { name: "SAIFULLA SARDAR", course: "SEM Model" },
  { name: "Mrs. Kalyani Kulkarni", course: "SEM Model" },
  { name: "A. Mary Dayana", course: "SEM Model" },
  { name: "Prof.Chaya Chavan -Tirvir", course: "SEM Model" },
  { name: "Preethi Karmakar", course: "SEM Model" },
  { name: "Ms.Ugin Juliyet M P", course: "SEM Model" },
  { name: "Mr. Abhishek Danu", course: "SEM Model" },
  { name: "Ms. Sasikala S", course: "SEM Model" },
  { name: "Mr. Yallappa C", course: "SEM Model" },
  { name: "Ms.R.Kavitha", course: "SEM Model" },
  { name: "Dr.Patteswari.D", course: "SEM Model" },
  { name: "Aakila M", course: "SEM Model" },
  { name: "Ms. G.NARMADHA", course: "SEM Model" },
  { name: "Mrs. Riya Panwar", course: "SEM Model" },
  { name: "Simran bisht", course: "SEM Model" },
  { name: "Dr. Sangeetha S R", course: "SEM Model" },
  { name: "Asit Kumar Mohanty", course: "SEM Model" },
  { name: "Ms.N.Deepika", course: "SEM Model" },
  { name: "Ms. Thirupukaz Arasi", course: "SEM Model" },
  { name: "Ms. Ashwini Shetty", course: "SEM Model" },
  { name: "Ms. Varalakshmi G", course: "SEM Model" },
  { name: "Gurpreet Kaur", course: "SEM Model" },
  { name: "Ms. Shilpa S", course: "SEM Model" },
  { name: "Mrs.Abirami M", course: "SEM Model" },
  { name: "Ms. P.Priyanka", course: "SEM Model" },
  { name: "Ms. Sakshi", course: "SEM Model" },
  { name: "Ms. Sushree Sangeeta ", course: "SEM Model" },
  { name: "Mukhi", course: "SEM Model" },
  { name: "Sabitri Bala Goyary", course: "SEM Model" },
  { name: "Ms. Amala Alys J", course: "SEM Model" },
  { name: "Mr. Trinkul Kalita", course: "SEM Model" },
  { name: "P. Susai Raj", course: "SEM Model" },
  { name: "Nisha M", course: "SEM Model" },
  { name: "Ms. Anjali Sankar", course: "SEM Model" },
  { name: "Mrs. T. SUBASHINI", course: "SEM Model" },
  { name: "Ms.Pavithra.R", course: "SEM Model" },
  { name: "Dr.Rafia Begum", course: "SEM Model" },
  { name: "Bhuvaneswari M", course: "SEM Model" },
  { name: "Premabati Sharma", course: "SEM Model" },
  { name: "Mr.Ashok Bhasme", course: "SEM Model" },
  { name: "Ms.K.Praveena", course: "SEM Model" },
  { name: "AKANKSHA SINGH", course: "SEM Model" },
  { name: "Mr. Gopilal Kisku", course: "SEM Model" },
  { name: "Mrs Rita Carral", course: "SEM Model" },
  { name: "Rajni Kumari", course: "SEM Model" },

  // ... Add 100+ entries
];

const PopupNotification = () => {
  const [visible, setVisible] = useState(true);
  const [current, setCurrent] = useState(getRandomStudent());

  function getRandomStudent() {
    return studentData[Math.floor(Math.random() * studentData.length)];
  }

  // Change student every 10 seconds if visible
  useEffect(() => {
    let changeInterval;
    if (visible) {
      changeInterval = setInterval(() => {
        setCurrent(getRandomStudent());
      }, 10000); // every 10 seconds
    }
    return () => clearInterval(changeInterval);
  }, [visible]);

  // If closed, restart popup after 2 minutes
  useEffect(() => {
    let timeout;
    if (!visible) {
      timeout = setTimeout(() => {
        setCurrent(getRandomStudent());
        setVisible(true);
      }, 20000); // 2 minutes
    }
    return () => clearTimeout(timeout);
  }, [visible]);

  return (
    <div className="fixed top-5 right-5 z-[10000]">
      <AnimatePresence>
        {visible && (
          <motion.div
            initial={{ opacity: 0, y: -20, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -20, scale: 0.9 }}
            transition={{ duration: 0.4 }}
            className="bg-white shadow-xl border rounded-lg px-4 py-3 flex justify-between items-start gap-3 w-80">
            <div className="flex flex-col">
              <p className="text-sm text-gray-800">
                🎓 <strong>{current.name}</strong> just enrolled.
              
              </p>
            </div>
            <button
              onClick={() => setVisible(false)}
              className="text-gray-600 hover:text-black mt-1">
              <IoClose size={20} />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default PopupNotification;
